var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHumanResourcesOld = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_21885_82889)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5094 6.9112C10.1243 7.08229 8.9712 7.71273 8.10873 8.76972C7.58141 9.41656 7.22987 10.1853 7.06581 11.0548C6.9955 11.4227 6.97675 12.2336 7.033 12.625C7.11268 13.2062 7.25565 13.6703 7.5111 14.1953C8.19545 15.5897 9.51024 16.6116 11.0102 16.9116C12.4796 17.2069 13.9093 16.8928 15.0952 16.0139C15.3951 15.7913 15.8943 15.2921 16.117 14.9921C17.249 13.464 17.4435 11.4368 16.6209 9.74233C15.8756 8.21427 14.4319 7.16666 12.7445 6.93229C12.5031 6.89714 11.718 6.88542 11.5094 6.9112ZM12.5546 8.45332C13.7288 8.6291 14.7038 9.34626 15.2475 10.4337C15.503 10.9423 15.6342 11.6782 15.5779 12.2618C15.4936 13.1008 15.1561 13.832 14.5725 14.4273C13.6304 15.3882 12.2382 15.7304 10.9633 15.3108C9.51024 14.8327 8.52122 13.4758 8.52122 11.9547C8.52122 11.0126 8.88917 10.1337 9.5618 9.45875C10.0094 9.01346 10.5039 8.7205 11.1133 8.54707C11.5562 8.42051 12.1 8.38536 12.5546 8.45332Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6964 9.93151C11.005 10.0838 10.4777 10.6065 10.3347 11.2744C10.2926 11.476 10.2926 11.8556 10.3371 12.0595C10.3863 12.2963 10.5527 12.6173 10.7308 12.8259L10.8808 13.0017L10.773 13.065C10.5316 13.1986 10.2363 13.4775 10.0348 13.7563L9.94336 13.8806L10.0348 13.9767C10.6019 14.5602 11.4925 14.8813 12.3245 14.7946C12.9643 14.7313 13.562 14.4618 14.0213 14.0329L14.1713 13.8899L14.0541 13.7235C13.9065 13.515 13.6276 13.2501 13.412 13.1118C13.3182 13.0509 13.2385 12.9993 13.2338 12.997C13.2292 12.9923 13.2831 12.9244 13.3557 12.847C13.808 12.3595 13.9416 11.6471 13.7002 11.0213C13.4963 10.4963 13.0604 10.1073 12.4933 9.94792C12.3104 9.89635 11.8909 9.88698 11.6964 9.93151Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8138 15.1752C16.4669 15.7048 15.8787 16.3025 15.3349 16.6704C15.2178 16.7501 15.1146 16.8204 15.1076 16.8251C15.0865 16.8438 16.8817 18.6203 16.9989 18.6977C17.2005 18.8289 17.4325 18.8945 17.7044 18.8945C18.2903 18.8945 18.7543 18.5617 18.9442 18.0063C19.0215 17.779 19.0192 17.4321 18.9395 17.193C18.9067 17.097 18.8528 16.9751 18.8199 16.9188C18.766 16.8321 16.9661 15.0041 16.9357 15.0041C16.9286 15.0041 16.8747 15.0814 16.8138 15.1752Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_21885_82889",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C5EDC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A9E3EB"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHumanResourcesOld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/human_resources_old.322d70e04ce5c570c6a4991e908ce01c.svg";